export default "__VITE_ASSET__3_qUYx_u__"